// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__KhYL4","tab":"ProcedureTabs_tab__Jnnc4"};